<script setup lang="ts">
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'HeaderTeamEdit',
})

const route = useRoute()

const config = computed<LinkBreadcrumbItem[]>(() => [
  { id: 'users', text: 'Users & teams', to: AppRoute.Users, disabled: false },
  { id: 'teams', text: 'Teams', to: AppRoute.Teams, disabled: false },
  { id: 'team', text: `Team / ${route.params.id as string}`, to: null, disabled: true },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
